import Routes from "./routes/Routes";
// import "style/global.scss";
import {
  GET_ORGANISATION_FROM_TENENT_ID,
  GET_PERSON_FROM_UID,
  GET_PRACTITIONER_FROM_UID,
  LOGOUT_FROM_SERVER,
} from "adapters/auth.service";
import {
  FETCH_COMPOSITION_FROM_ID,
  FETCH_PATIENT_FROM_ID,
  GET_ARCHIVED_ENCOUNTERS,
  GET_BASIC_RESOURCE,
  GET_COMPOSITION_WITH_ID,
  GET_CUSTOMER_SUBSCRIPTION,
  GET_PLANS_LIST,
  GET_USER_PRACITCE_DATA,
  GET_USER_SETTINGS,
  GET_VOICE_EDIT_SETTINGS,
  SAVE_USER_SETTINGS,
  SAVE_VOICE_EDIT_SETTINGS,
} from "adapters/ehr.service";
import {
  SYNC_EHR_ENCOUNTER_RESOURCES_WITH_PATIENTID,
  SYNC_EHR_ENCOUNTER_RESOURCES_WITH_PATIENTID_FOR_ENLIV,
} from "adapters/ehrbridge.service";
import axios from "axios";
import UnauthorizedAccess from "components/dialogs/UnauthorizedAccess";
import IdleController from "components/idle/IdleController";
import FallBackLoader from "components/loader/FallbackLoader";
import { getAvailableTemplates } from "components/SpeechToText_v2/helpers/getAvailbleTemplates";
import {
  cacheTenantIds,
  filterOldObjectsWithModifiedDays,
  handleBulkDeleteEncounter,
  killIntervals,
} from "config/helpers/common_helper";
import { TRIAL } from "config/helpers/license_helper";
import {
  parseLicenseFromSetting,
  upgradeLicense,
} from "config/helpers/licensing_helper";
import dayjs from "dayjs";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/plugins.pkgd.min.css";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import jwtDecode from "jwt-decode";
import { isLocaleAvailable } from "multilingual";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  add_user_data,
  change_app_language,
  change_audio_language,
  change_login,
  full_page_loader,
  reset_state,
  set_iframe_screen_type,
} from "redux/actions/AppActions";
import {
  set_current_user_practice_data,
  set_current_user_setting,
  set_organistion_details,
  set_person_details,
  set_practitioner_details,
  set_user_template_preferences,
  set_voice_edit_setting,
} from "redux/actions/AuthActions";
import {
  encounterObject,
  setCurrentComposition,
} from "redux/actions/EncounterActions";
import { setLicense, setPlanStatus } from "redux/actions/LicenseAction";
import { setNJTemplateUser } from "redux/actions/NJTemplateUserActions";
import { patientObject } from "redux/actions/PatientActions";
import {
  reset_subscription,
  set_available_plans,
  set_current_subscription,
} from "redux/actions/SubscriptionAction";
import { setTokenExpired } from "redux/actions/TokenActions";
import { constants } from "redux/constants/redux-constants";
import { setEHRData } from "redux/reducers/IntegratedEHRSlice";
import SessionInvalid from "screens/fallbacks/SessionInvalid";
import { getCurrentPlan, getPlanStatus } from "screens/store/storeHelper";
import getCurrentAudioLanguage from "./getCurrentAudioLanguage";
import getCurrentLanguage from "./getCurrentLanguage";

const App = ({ setDatadogUser }) => {
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lockedCybermedPath = useRef(null);
  let shouldShowTrialScreen = false;

  // const language = useSelector((state) => state.app?.language, isEqual);
  // const app = useSelector((state) => state.app, isEqual);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const isSessionValidated = useRef(null);
  const [tokenInvalid, setTokenInvalid] = useState(false);

  const getPromptList = async () => {
    const availablePrompts = await getAvailableTemplates();
    console.log("prompts", availablePrompts);

    // const isNJTemplateUser = availablePrompts.some(prompt => prompt.promptName.toLowerCase().includes("history and physical examination"));
    const isNJTemplateUser = availablePrompts?.some((prompt) =>
      prompt.promptName.toLowerCase().includes("women"),
    );
    console.log("njtemplate", isNJTemplateUser);
    reduxDispatch(setNJTemplateUser(isNJTemplateUser));
    reduxDispatch(set_user_template_preferences({ display: availablePrompts }));
  };

  const getUserSubscription = async () => {
    const currentSubscription = await GET_CUSTOMER_SUBSCRIPTION();

    if (currentSubscription) {
      reduxDispatch(set_current_subscription(currentSubscription));
      return currentSubscription;
    }
  };

  const getPlans = async () => {
    try {
      const res = await GET_PLANS_LIST();
      reduxDispatch(set_available_plans(res?.products));
      return res?.products;
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      setTokenInvalid(e.detail);
    };
    window.addEventListener("tokenInvalidChanged", handler);
    // If setTokenInvalidGlobal was called before mount
    if (window.__setTokenInvalid) setTokenInvalid(true);
    return () => window.removeEventListener("tokenInvalidChanged", handler);
  }, []);

  useEffect(() => {
    setCurrentLocation(window.location?.pathname);
  }, [window.location]);

  useEffect(() => {
    if (
      lockedCybermedPath.current &&
      !location.pathname.includes("/cybermed") &&
      !location.pathname.includes("/session/invalid")
    ) {
      navigate(lockedCybermedPath.current, { replace: true });
    }
  }, [location.pathname]);

  function base64UrlToBase64(str) {
    // Add padding
    str += "=".repeat((4 - (str.length % 4)) % 4);
    // Replace URL-safe chars
    return str.replace(/-/g, "+").replace(/_/g, "/");
  }

  useEffect(() => {
    const handleSession = async () => {
      isSessionValidated.current = true;
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("sessionToken");
      try {
        // Step 1: Generate New Access token for Noki
        const tokenParts = token.split(".");
        const payloadBase64 = base64UrlToBase64(tokenParts[1]);
        const decodedPayload = JSON.parse(atob(payloadBase64));

        const conversationId = decodedPayload?.ctx?.conversationId;
        const externalAppId = decodedPayload?.iss;
        const externalPatientId = decodedPayload?.ctx?.patient_id;
        const externalEncounterId = decodedPayload?.ctx?.encounter_id;
        const externalEncounterTitle = decodedPayload?.ctx?.title || "";
        const startup_screen = decodedPayload?.ctx?.startup_screen;
        const startup_screen_type = decodedPayload?.ctx?.screen_type;

        reduxDispatch({
          type: constants.SCRIBE.SET_STARTUP_SCREEN,
          payload: startup_screen,
        });

        reduxDispatch({
          type: "SET_EXTERNAL_ENCOUNTER_INFO",
          payload: {
            externalEncounterId,
            externalEncounterTitle,
          },
        });

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/auth-app/token`,
          { assertion: token },
          {
            headers: { "Content-Type": "application/json" },
          },
        );
        const { accessToken, refreshToken } = res.data;

        localStorage.setItem("jwtToken", accessToken);
        localStorage.setItem("firebaseRefreshToken", refreshToken);

        if (!accessToken) {
          throw new Error("No access token returned from server");
        }

        if (
          startup_screen_type === "external" ||
          startup_screen_type === "inline"
        ) {
          reduxDispatch(set_iframe_screen_type(startup_screen_type));
        } else if (startup_screen_type) {
          throw new Error("Value of screen_type is invalid");
        }
        if (!conversationId) {
          throw new Error("Conversation ID is Empty");
        } else if (conversationId) {
          const conversation = await GET_COMPOSITION_WITH_ID(conversationId);
          if (!conversation?.total) {
            throw new Error("Invalid Conversation ID");
          }
        }

        await userLogIn(accessToken);

        if (
          conversationId &&
          startup_screen === "scribe.conversation.record.lite"
        ) {
          const [patientResource, encounterId] = await processConversationId(
            conversationId,
          );
          reduxDispatch(
            setEHRData({
              connectionId: "",
              ehrName: "",
            }),
          );
          await handleCybermedRedirect(patientResource, encounterId);
        } else if (startup_screen === "scribe.conversation.record") {
          const jwtPayLoad = jwtDecode(accessToken);
          const nokiTenantId = jwtPayLoad?.firebase?.tenant;

          const [patientResource, encounterId] = await processConversationId(
            conversationId,
          );

          await handle_Neomed_Redirect(patientResource, encounterId);
        } else {
          throw new Error("No Noki Startup Screen Specified");
        }
      } catch (err) {
        const errorMsg = err?.response?.data || err.message;
        console.error("Token/Connection/Sync failed:", errorMsg);
        window.parent.postMessage(
          { type: "scribe.session.token.invalid", error: errorMsg },
          "*",
        );
        setTokenInvalid(true); // mark invalid
        setIsFirebaseLoaded(true);
      }
    };
    if (!isSessionValidated.current) {
      handleSession();
    }
  }, []);

  const processConversationId = async (conversationId) => {
    const currentComposition = await FETCH_COMPOSITION_FROM_ID(conversationId);
    const compositionResource = currentComposition?.entry?.[0]?.resource;

    reduxDispatch(setCurrentComposition(compositionResource));
    const encounterId =
      compositionResource?.encounter?.reference?.split("/")?.[1];

    const patientId =
      currentComposition?.entry?.[0]?.resource?.subject?.reference?.split(
        "/",
      )?.[1];
    const patientResource = await FETCH_PATIENT_FROM_ID(patientId);
    return [patientResource?.entry?.[0]?.resource, encounterId];
  };

  const createConnectionAndSyncPatient = async ({
    app_id,
    tenant_id,
    config_secret_name,
    patientId,
    encounterId,
    dispatch,
  }) => {
    try {
      const connectionPayload = {
        app_id,
        tenant_id,
        config_secret_name,
      };

      const { data: connectionRes } = await axios.post(
        `${process.env.REACT_APP_EHR_PROXY_URL}/api/enliv/sync`,
        connectionPayload,
      );

      const connectionId = connectionRes?.connectionId;
      if (!connectionId)
        throw new Error("Connection ID not returned from proxy");

      console.log("Connection established:", connectionRes);

      dispatch(
        setEHRData({ connectionId: "", ehrName: connectionRes?.ehrName }),
      );

      //Call the shared function instead of duplicating sync logic
      await syncPatientWithExistingConnection({
        tenant_id,
        connectionId,
        patientId,
        encounterId,
      });
    } catch (err) {
      console.error("Failed in connection or patient sync:", err.message);
    }
  };

  const syncPatientWithExistingConnection = async ({
    tenant_id,
    connectionId,
    patientId,
    encounterId,
  }) => {
    try {
      const { data: syncData } = await axios.post(
        `${process.env.REACT_APP_EHR_PROXY_URL}/api/tenants/${tenant_id}/patient/sync/${connectionId}`,
        { patientId },
      );
      await handlePatientScreenRedirect(syncData, encounterId);
      console.log("Patient synced to Noki (existing connection):", syncData);
    } catch (err) {
      console.error("Sync failed for existing connection:", err.message);
    }
  };

  const handlePatientScreenRedirect = async (
    nokiPatientResource,
    externalEncounterId,
  ) => {
    try {
      if (!nokiPatientResource?.id)
        toast.error("Patient Resource not received");

      const { value: externalPatientId } =
        nokiPatientResource?.identifier?.find((item) =>
          item?.system?.endsWith("external-patient-id"),
        );

      if (Boolean(externalPatientId)) {
        await SYNC_EHR_ENCOUNTER_RESOURCES_WITH_PATIENTID(
          nokiPatientResource?.id,
          externalPatientId,
        );
        const bundle =
          await SYNC_EHR_ENCOUNTER_RESOURCES_WITH_PATIENTID_FOR_ENLIV(
            nokiPatientResource?.id,
          );

        const matchingEncounter = bundle?.entry?.find((entry) => {
          return entry.resource?.identifier?.some(
            (id) =>
              id.system === "external-encounter-id" &&
              id.value === externalEncounterId,
          );
        });

        const nokiEncounterId = matchingEncounter?.resource?.id;

        const encounterQuery = nokiEncounterId
          ? `?tabId=0&visitId=${nokiEncounterId}`
          : "";

        navigate(
          `/patients/visits/${nokiPatientResource?.id}${encounterQuery}`,
          {
            state: {
              rawData: nokiPatientResource,
              isEHR: true,
            },
          },
        );

        reduxDispatch(encounterObject(bundle));
      }
      setIsFirebaseLoaded(true);
      reduxDispatch(patientObject(nokiPatientResource));
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handle_Neomed_Redirect = async (
    nokiPatientResource,
    nokiEncounterId,
  ) => {
    try {
      if (!nokiPatientResource?.id)
        toast.error("Patient Resource not received");

      const encounterQuery = nokiEncounterId
        ? `?tabId=0&visitId=${nokiEncounterId}`
        : "";
      navigate(
        `/patients/visits/${nokiPatientResource?.id}/neomed/${encounterQuery}`,
        { replace: true },
      );
      // reduxDispatch(autoStartRecording(true));
      setIsFirebaseLoaded(true);
      reduxDispatch(encounterObject([]));
      reduxDispatch(patientObject(nokiPatientResource));
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCybermedRedirect = async (
    nokiPatientResource,
    nokiEncounterId,
  ) => {
    try {
      if (!nokiPatientResource?.id)
        toast.error("Patient Resource not received");

      const encounterQuery = nokiEncounterId
        ? `?tabId=0&visitId=${nokiEncounterId}`
        : "";
      const cyberPath = `/patients/visits/${nokiPatientResource?.id}/cybermed/${encounterQuery}`;
      lockedCybermedPath.current = cyberPath;
      navigate(cyberPath, { replace: true });
      // reduxDispatch(autoStartRecording(true));
      setIsFirebaseLoaded(true);
      reduxDispatch(encounterObject([]));
      reduxDispatch(patientObject(nokiPatientResource));
    } catch (error) {
      toast.error(error?.message);
    }
  };

  // useEffect(() => {
  //   window.parent.postMessage(
  //     { type: "is-recording", label: isRecording },
  //     "*"
  //   );
  // }, [isRecording]);

  const createUserSetting = async (userId) => {
    const language = getCurrentLanguage();
    const audioLanguage = getCurrentAudioLanguage();

    // const systemLanguage = navigator?.language || navigator?.userLanguage;
    // const languageCode = language || systemLanguage.split("-")[0] || "en";
    const languageCode = language || isLocaleAvailable() || "en";
    const audioLanguageCode =
      // audioLanguage || systemLanguage.split("-")[0] || "en";
      audioLanguage || isLocaleAvailable() || "en";

    let setting = {
      theme: "light",
      language: languageCode || "en",
      isIntroDone: false,
      isNewUser: true,
      isWelcomeScreenShown: false,
      audioLanguage: audioLanguageCode || "en",
      print_watermark: true,
      dashboard_selected_widgets: [
        "Start Encounter",
        "Search Patient",
        "Create Patient",
        "Clinical Notes",
      ],
      auto_delete_days: "never",
      CDSSHidden: false,
      diagnosisJustification: false,
      RememberSOAPContextCarryForward: "ask",
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.preference.ui",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/settings/data",
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };

  const providerPracticeData = async (userId) => {
    const practice_data = {
      practice_speciality: null,
      practice_ehr: null,
      isFirstVisitSkipped: false,
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.preference.practice",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/practice/data",
          valueString: JSON.stringify(practice_data),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };

  const createVoiceEditSetting = async (userId) => {
    let setting = {
      voiceEditTime: 0,
      voiceEditCount: 0,
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.voiceEdit.time",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/settings/data",
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_VOICE_EDIT_SETTINGS(`POST`, payload);
    return response;
  };

  const addLicense = async (userId, license = TRIAL) => {
    let license_package = {
      license: license,
      resetCount: 0,
      payload: {
        cdss: 0,
        encounters: 0,
        scribes: 0,
        minutes: 0,
        icd_cpt_codes: 0,
        ai_voice_edit: 0,
        each_scribe_minutes: 0,
      },
    };
    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.license",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/license/data",
          valueString: JSON.stringify(license_package),
        },
      ],
    };

    try {
      const response = await SAVE_USER_SETTINGS(`POST`, payload);
      const rawData = { ...response?.data };
      const licenseSetting = rawData?.extension?.find(
        (item) => item?.url === "http://enliv.com/license/data",
      )?.valueString;
      return { valueString: licenseSetting, id: rawData?.id };
    } catch (e) {
      console.error(e);
    } finally {
    }
  };

  const updateLicenseIfNeeded = async (currentPlan, licenseTempLoad) => {
    if (currentPlan !== licenseTempLoad?.license) {
      // If Current Plan is not equal to plan stored in FHIRBasic, update the FHIRBasic
      const response = await upgradeLicense({
        license: currentPlan,
        id: licenseTempLoad.id,
      });
      reduxDispatch(setLicense(response));
    } else {
      reduxDispatch(setLicense(licenseTempLoad));
    }
  };

  const handleLicenseSetting = async (
    licenseSetting,
    availablePlans,
    currentSubscription,
    PersonID,
  ) => {
    const currentPlan =
      availablePlans
        ?.find(
          (plan) =>
            plan?.id ===
            currentSubscription?.subscriptions?.[0]?.obj_data?.plan?.product,
        )
        ?.name.toUpperCase() || "TRIAL";
    if (licenseSetting?.data?.total) {
      const licenseTempLoad = parseLicenseFromSetting(licenseSetting);
      if (licenseTempLoad) {
        await updateLicenseIfNeeded(currentPlan, licenseTempLoad);
      }
    } else {
      const newLicenseSetting = await addLicense(PersonID, currentPlan);
      try {
        reduxDispatch(
          setLicense({
            ...JSON.parse(newLicenseSetting?.valueString),
            id: newLicenseSetting?.id,
          }),
        );
      } catch (error) {
        console.error("Error parsing new license data", error.message);
      }
    }
  };

  const checkEncExp = async ({ practitionerId, expDaysLimit }) => {
    if (expDaysLimit === "never") return false;
    try {
      let res = await GET_ARCHIVED_ENCOUNTERS(practitionerId, "", 100);
      if (res?.entry?.length > 0) {
        res = res?.entry?.filter(
          (f) => f?.resource?.resourceType !== "Patient",
        );
        if (res?.length > 0) {
          const readyToDel = filterOldObjectsWithModifiedDays(
            res,
            expDaysLimit,
          );
          if (readyToDel?.length > 0) {
            await handleBulkDeleteEncounter(readyToDel);
          }
        }
      }
    } catch (e) {
      console.error("error: ", e);
    }
  };

  const userLogIn = async (token) => {
    localStorage?.setItem("jwtToken", token);
    const jwtPayLoad = jwtDecode(token);
    reduxDispatch(
      add_user_data({
        resource: jwtPayLoad,
        userId: jwtPayLoad?.user_id,
      }),
    );
    reduxDispatch(change_login(constants?.USER_CHECK_LOGIN));
    setDatadogUser(
      jwtPayLoad?.name,
      jwtPayLoad?.email,
      jwtPayLoad?.firebase?.tenant,
    );

    await hyderateApp();
  };

  const hyderateApp = async () => {
    const jwtPayload = jwtDecode(localStorage.getItem("jwtToken"));
    const uid = jwtPayload?.user_id;
    try {
      await getLoggedInPersonData(uid);
    } catch (error) {
      console.log(error);
    }
  };

  const getLoggedInPersonData = async (uid) => {
    setIsUserDataLoaded(false);
    getPromptList();
    const currentSubscription = await getUserSubscription();
    reduxDispatch(
      setPlanStatus(getPlanStatus(currentSubscription?.subscriptions)),
    );
    const availablePlans = await getPlans();
    try {
      let response = await GET_PERSON_FROM_UID(uid);
      const PersonID = response?.resource?.id;
      const jwtPayload = jwtDecode(localStorage.getItem("jwtToken"));
      const tenantId = jwtPayload?.firebase?.tenant;
      if (PersonID) {
        reduxDispatch(set_person_details(response?.resource));
        // let resource = await GET_RELATED_PERSONS(
        //   response?.resource?.link || []
        // );
        // reduxDispatch(set_related_persons_details(resource));

        const OrganisationData = await GET_ORGANISATION_FROM_TENENT_ID(
          tenantId,
        );
        reduxDispatch(set_organistion_details(OrganisationData?.resource));

        let PractitionerData = await GET_PRACTITIONER_FROM_UID(uid);
        if (!PractitionerData?.resource?.id) {
          // PractitionerData = await createPractitionerFromPerson(
          //   { ...response?.resource },
          //   uid
          // )
          alert(
            "Oops! There was an error loading your data. The page will now refresh.",
          );
          window.location.reload();
        }

        reduxDispatch(
          set_practitioner_details(
            PractitionerData?.resource || PractitionerData?.data,
          ),
        );

        let currentUserPracticeData = await GET_USER_PRACITCE_DATA(PersonID);
        let currentUserSetting = await GET_USER_SETTINGS(PersonID);
        let licenseSetting = await GET_BASIC_RESOURCE({
          resourceName: "user.license",
          personId: PersonID,
        });
        handleLicenseSetting(
          licenseSetting,
          availablePlans,
          currentSubscription,
          PersonID,
        );

        if (currentUserPracticeData?.data?.total) {
          const rawData = {
            ...currentUserPracticeData?.data?.entry?.[0]?.resource,
          };
          const practiceData = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/practice/data",
          )?.valueString;

          reduxDispatch(
            set_current_user_practice_data({
              resource: { ...rawData },
              practiceData: JSON?.parse(practiceData),
            }),
          );
        } else {
          const practiceResponse = await providerPracticeData(PersonID);
          reduxDispatch(
            set_current_user_practice_data({
              resource: { ...practiceResponse?.data },
              practiceData: JSON?.parse(
                await practiceResponse?.data?.extension?.[0]?.valueString,
              ),
            }),
          );
        }
        let auto_delete_days;
        if (currentUserSetting?.data?.total) {
          const rawData = {
            ...currentUserSetting?.data?.entry?.[0]?.resource,
          };
          const displaySetting = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/settings/data",
          )?.valueString;

          let savedSettings = JSON?.parse(displaySetting);
          auto_delete_days = savedSettings?.auto_delete_days;
          const supportedLanguages = ["en", "es", "fr-FR", "pl-PL"];
          if (
            !savedSettings?.language ||
            !supportedLanguages.includes(savedSettings?.language)
            // (savedSettings?.language !== "en" &&
            //   savedSettings?.language !== "es" && savedSettings?.language !== "pl" && savedSettings?.language !== "fr")
          ) {
            const systemLanguage =
              navigator?.language || navigator?.userLanguage || "en";
            const languageCode = systemLanguage.split("-")[0];
            savedSettings.language = languageCode || "en";
          }
          if (savedSettings?.isWelcomeScreenShown === false) {
            shouldShowTrialScreen = true;
          }
          reduxDispatch(
            set_current_user_setting({
              resource: { ...rawData },
              display: {
                ...savedSettings,
                //  theme: "light"
              },
            }),
          );
          reduxDispatch(
            change_audio_language(savedSettings?.audioLanguage || "en"),
          );
        } else {
          shouldShowTrialScreen = true;
          const responseSetting = await createUserSetting(PersonID);
          reduxDispatch(
            set_current_user_setting({
              resource: { ...responseSetting?.data },
              display: JSON?.parse(
                responseSetting?.data?.extension?.[0]?.valueString,
              ),
            }),
          );
          auto_delete_days = JSON?.parse(
            responseSetting?.data?.extension?.[0]?.valueString,
          )?.auto_delete_days;
        }

        await checkEncExp({
          practitionerId: PractitionerData?.resource?.id,
          expDaysLimit: auto_delete_days || "never", // If auto_delete_days is not defined then setting it to 90 days by default to automatically delete encounters after they have been soft deleted
        });

        let voiceEditSettings = await GET_VOICE_EDIT_SETTINGS(PersonID);
        //
        if (voiceEditSettings?.data?.total) {
          const rawData = {
            ...voiceEditSettings?.data?.entry?.[0]?.resource,
          };
          const displaySetting = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/settings/data",
          )?.valueString;

          let savedSettings = JSON?.parse(displaySetting);
          reduxDispatch(
            set_voice_edit_setting({
              resource: { ...rawData },
              display: {
                ...savedSettings,
              },
            }),
          );
        } else {
          const responseSetting = await createVoiceEditSetting(PersonID);
          reduxDispatch(
            set_voice_edit_setting({
              resource: { ...responseSetting?.data },
              display: JSON?.parse(
                responseSetting?.data?.extension?.[0]?.valueString,
              ),
            }),
          );
        }

        setIsUserDataLoaded(true);
      }
    } catch (e) {
      reduxDispatch(full_page_loader(false));
      throw e;
      console.error(e);
    } finally {
      reduxDispatch(full_page_loader(false));
    }
  };

  const refreshUserData = async (firebaseUser, isFirebaseLoaded) => {
    if (isFirebaseLoaded) {
      reduxDispatch(full_page_loader(true));
      if (firebaseUser) {
        await getLoggedInPersonData(firebaseUser?.uid);
        if (shouldShowTrialScreen && getCurrentPlan() === "TRIAL") {
          navigate(`/welcome`, { replace: true, state: { newUser: true } });
        } else {
          if (currentLocation === "/login") {
            navigate(`/home/dashboard`, { replace: true });
          }
        }
        cacheTenantIds({
          tenantId: firebaseUser?.tenantId,
          email: firebaseUser?.email,
        });
      } else {
        // const tempLang = language;
        const language = getCurrentLanguage();
        reduxDispatch(change_login(constants?.USER_LOGOUT));
        reduxDispatch(reset_state());
        reduxDispatch(change_app_language(language || "en"));
        // navigate(`/login`, { replace: true });
        setIsUserDataLoaded(true);
      }
    }
  };

  const [exitButtonLoading, setExitButtonLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setExitButtonLoading(true);
      killIntervals();
      const language = getCurrentLanguage();
      reduxDispatch(change_login(constants?.USER_LOGOUT));
      reduxDispatch(reset_state());
      reduxDispatch(change_app_language(language || "en"));
      reduxDispatch(reset_subscription());
      let logoutData = await LOGOUT_FROM_SERVER();
      reduxDispatch(setTokenExpired(true));
    } catch (err) {
    } finally {
      setExitButtonLoading(false);
    }
  };

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      const handleMessage = (event) => {
        if (event.data?.type === "NEW_VERSION") {
          console.log("Received version update:", event.data);
          const confirmUpdate = window.confirm(
            `A new version (${event.data.version}) is available!\n\nClick on OK to reload.`,
          );

          // Reload the page if the user confirms
          if (confirmUpdate) {
            window.location.reload();
          }
        }
      };

      // Listen for messages from the controlling service worker
      navigator.serviceWorker.controller?.addEventListener(
        "message",
        handleMessage,
      );

      // Handle future controller changes
      const handleControllerChange = () => {
        navigator.serviceWorker.controller?.addEventListener(
          "message",
          handleMessage,
        );
      };

      navigator.serviceWorker.addEventListener(
        "controllerchange",
        handleControllerChange,
      );

      return () => {
        navigator.serviceWorker.controller?.removeEventListener(
          "message",
          handleMessage,
        );
        navigator.serviceWorker.removeEventListener(
          "controllerchange",
          handleControllerChange,
        );
      };
    }
  }, []);

  return (
    <>
      <UnauthorizedAccess open={open} setOpen={setOpen} />
      <IdleController
        handleLogout={handleLogout}
        exitButtonLoading={exitButtonLoading}
      />
      {tokenInvalid ? (
        <SessionInvalid />
      ) : isFirebaseLoaded ? (
        <Routes />
      ) : (
        <FallBackLoader loaderMessage={true} />
      )}
    </>
  );
};

export default App;
